import { FC, useCallback, useState } from "react";
import CircleIconButton from "./CircleIconButton";
import Tooltip, { TooltipProps } from "../tooltip/Tooltip";
import { useScroll } from "../../../utils/hooks/use-scroll";


interface CircleIconButtonTooltipProps extends TooltipProps {
  icon: React.ReactNode;
  closeOnScroll?: boolean;
}

const CircleIconButtonTooltip: FC<CircleIconButtonTooltipProps> = ({
  icon,
  closeOnScroll,
  children,
  ...props
}) => {
  const [open, setOpen] = useState(false);

  const setClosed = useCallback(
    () => (closeOnScroll ? setOpen(false) : void 0),
    [closeOnScroll]
  );

  useScroll(setClosed, document);

  return (
    <>
      <Tooltip
        open={open}
        on="click"
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        arrow={false}
        repositionOnResize
        position={"bottom right"}
        {...props}
        trigger={
          <span>
            <CircleIconButton active={open} icon={icon} />
          </span>
        }
      >
        {children}
      </Tooltip>
    </>
  );
};

export default CircleIconButtonTooltip;
